import { render, staticRenderFns } from "./DialpadMobileLikeCopy.vue?vue&type=template&id=1bd9192f&scoped=true&"
import script from "./DialpadMobileLikeCopy.vue?vue&type=script&lang=js&"
export * from "./DialpadMobileLikeCopy.vue?vue&type=script&lang=js&"
import style0 from "./DialpadMobileLikeCopy.vue?vue&type=style&index=0&id=1bd9192f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9192f",
  null
  
)

export default component.exports